import React from "react";
import {Link} from "react-router-dom";
import "../styles/MamahoodHomepage.css";

const happeningItems = [
    {
        title: "Virtual Community",
        text: "We've got 20 topic-specific chat groups waiting for you.",
        icon: "💬",
        color: "salmon",
    },
    {
        title: "In Person Events",
        text: "Check our calendar to find out where mamas are meeting up.",
        icon: "📅",
        color: "coral",
    },
    {
        title: "Inspiration",
        text: "Helpful mothering articles by moms for mom.",
        icon: "💡",
        color: "mustard",
    },
    {
        title: "Podcasts",
        text: "Authentic conversations with working moms.",
        icon: "🎙️",
        color: "mint",
    },
    {
        title: "Resources",
        text: "We curate an exciting list of mama-products and services.",
        icon: "M",
        color: "teal",
    },
];

const storyCards = [
    {
        title: "Article for Moms in the thick of it",
        action: "Read",
        image: "/static/img/lau-55.png",
        to: "/twentytwentysix/resources"
    },
    {
        title: "Connect with local moms in your area",
        action: "Events",
        image: "/static/img/AdobeStock_179076750.jpeg",
        to: "/twentytwentysix/events"
    },
    {
        title: "Virtual community of moms available 24/7",
        action: "Chats",
        image: "/static/img/AdobeStock_179076750.jpeg",
        to: "/twentytwentysix/resources"
    },
    {
        title: "Podcasts with inspiring entrepreneurs.",
        action: "Listen",
        image: "/static/img/AdobeStock_179076750.jpeg",
        to: "/twentytwentysix/podcasts"
    },
    {title: "The Mamahood podcast", action: "Listen", image: "/static/img/AdobeStock_179076750.jpeg", to: "/twentytwentysix/podcasts"},
    {
        title: "Grow your business with The Mamahood Collective",
        action: "Join",
        image: "/static/img/AdobeStock_179076750.jpeg",
        to: "/twentytwentysix/collective"
    },
];

const nowCards = [
    {
        title: "Virtual Events",
        text: "Stay connected with other moms from home",
        image: "/static/img/AdobeStock_179076750.jpeg",
    },
    {
        title: "Local Gatherings",
        text: "Connect with local moms in your area",
        image: "/static/img/AdobeStock_179076750.jpeg",
    },
    {
        title: "Moving Together",
        text: "Initiatives for yourself, family and community",
        image: "/static/img/AdobeStock_179076750.jpeg",
    },
];

const programs = [
    {
        title: "Moving in Motion",
        subtitle: "A social impact series centered around the Bay Area community",
        image: "/static/img/AdobeStock_179076750.jpeg",
        theme: "mustard",
        imagePosition: "50% 32%",
        imageScale: 1.12,
    },
    {
        title: "Mamahood Experiences",
        subtitle: "Explore our programs to get and give support with other mamas",
        image: "/static/img/AdobeStock_185103610.jpeg",
        theme: "coral",
        imagePosition: "50% 38%",
        imageScale: 1.08,
    },
    {
        title: "Yoga For Moms",
        subtitle: "Yoga series in Walnut Creek running through March and April 2026",
        image: "/static/img/AdobeStock_440987972.jpeg",
        theme: "pink",
        imagePosition: "50% 70%",
        imageScale: 1.06,
    },
];

const testimonials = [
    {
        quote: "POOP The Mamahood is my go-to for anything kid or mothering-related.",
        body:
            "I've had so many moments of doubt and a simple post and the positive support I get, makes being a mom so much more doable.",
        author: "Sophia Amazingmama",
        meta: "Mom of 2",
        image: "/static/img/AdobeStock_179076750.jpeg",
        theme: "teal",
        reverse: false,
        imagePosition: "48% 42%",
        imageScale: 1.02,
    },
    {
        quote: "The Mamahood is so inclusive and loving which means everything.",
        body:
            "I've had so many moments of doubt and a simple post and the positive support I get, makes being a mom so much more doable.",
        author: "Sophia Amazingmama",
        meta: "Mom of 2",
        image: "/static/img/AdobeStock_179076750.jpeg",
        theme: "mustard",
        reverse: true,
    },
    {
        quote: "I just can't say enough about how much happier I am with this community.",
        body:
            "I've had so many moments of doubt and a simple post and the positive support I get, makes being a mom so much more doable.",
        author: "Sophia Amazingmama",
        meta: "Mom of 2",
        image: "/static/img/AdobeStock_179076750.jpeg",
        theme: "coral",
        reverse: false,
    },
];

const categories = [
    {
        title: "New Moms",
        image: "/static/img/AdobeStock_179076750.jpeg",
        ctas: ["Expecting & New Moms", "Parenting", "Philanthropy"],
    },
    {
        title: "Health & Wellness",
        image: "/static/img/AdobeStock_179076750.jpeg",
        ctas: ["Health & Wellness", "Money & Career", "Classes & Workshops"],
    },
    {
        title: "Money & Career",
        image: "/static/img/AdobeStock_179076750.jpeg",
        ctas: ["Just For Moms", "Lifestyle / Travel", "Marriage Counseling"],
    },
];

export default function HomePage() {
    return (
        <div className="mh-site">
            <section className="mh-hero">
                <div className="mh-hero__overlay mh-container">
                    <h1 className="mh-hero__title">Nailing this mama-thing together</h1>
                    <Link to="/twentytwentysix/join" className="mh-pill">
                        Join →
                    </Link>
                </div>
            </section>

            <section className="mh-welcome section-light">
                <div className="mh-container">
                    <p className="mh-eyebrow">WELCOME TO THE MAMAHOOD</p>
                    <h2 className="mh-script">
                        Where we mamas go to lift each other up &amp; be supported ourselves
                    </h2>
                    <p className="mh-copy mh-copy--center">
                        We offer FREE support like chat groups, articles, podcasts, events
                        and resources for Bay Area, California mamas.
                    </p>

                    <div className="mh-region-row">
                        <Link to="/twentytwentysix/events" className="mh-pill mh-pill--region coral">
                            San Francisco Bay Area →
                        </Link>
                        <Link to="/twentytwentysix/events" className="mh-pill mh-pill--region mustard">
                            Sacramento Valley →
                        </Link>
                        <Link to="/twentytwentysix/events" className="mh-pill mh-pill--region pink">
                            LA County →
                        </Link>
                    </div>

                    <div className="mh-happening-grid">
                        <div className="mh-happening-left">
                            <h3 className="mh-section-title">SEE WHAT&apos;S HAPPENING:</h3>
                            <div className="mh-happening-list">
                                {happeningItems.map((item) => (
                                    <article className={`mh-happening-card ${item.color}`} key={item.title}>
                                        <div className="mh-happening-card__icon">{item.icon}</div>
                                        <div className="mh-happening-card__body">
                                            <h4>{item.title}</h4>
                                            <p>{item.text}</p>
                                        </div>
                                        <div className="mh-happening-card__arrow">→</div>
                                    </article>
                                ))}
                            </div>
                        </div>

                        <aside className="mh-membership-box">
                            <h3 className="mh-section-title">EXPLORE MEMBERSHIP:</h3>

                            <div className="mh-membership-tier">
                                <div className="mh-round-logo">M</div>
                                <h4>For All Moms</h4>
                                <p>
                                    Starting with our <strong>FREE</strong> membership, you can
                                    always upgrade for more resources.
                                </p>
                                <Link to="/twentytwentysix/join" className="mh-pill mh-pill--gold">
                                    Become a Member Today →
                                </Link>
                            </div>

                            <div className="mh-membership-divider"/>

                            <div className="mh-membership-tier">
                                <div className="mh-round-logo mh-round-logo--small">TMC</div>
                                <h4>For Women+ Entrepreneurs</h4>
                                <p>
                                    Join <strong>800+</strong> women+ entrepreneurs building
                                    sustainable businesses.
                                </p>
                                <Link to="/twentytwentysix/collective" className="mh-pill mh-pill--gold">
                                    Join The Mamahood Collective →
                                </Link>
                            </div>
                        </aside>
                    </div>
                </div>
            </section>

            <section className="mh-stories section-mustard" id="resources">
                <div className="mh-container">
                    <h3 className="mh-section-title mh-section-title--center">
                        FEATURED STORIES &amp; CONVERSATIONS
                    </h3>
                    <div className="mh-story-grid">
                        {storyCards.map((card) => (
                            <article className="mh-story-card" key={card.title}>
                                <img src={card.image} alt={card.title}/>
                                <div className="mh-story-card__content">
                                    <p>{card.title}</p>
                                    <Link to={card.to} className="mh-inline-btn">
                                        {card.action} <span>→</span>
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                    <Link className="mh-link-row" to="/twentytwentysix/resources">
                        All Resources →
                    </Link>
                </div>
            </section>

            <section className="mh-now section-light" id="events">
                <div className="mh-container">
                    <h3 className="mh-section-title mh-section-title--center teal-text">
                        WHAT&apos;S HAPPENING NOW?
                    </h3>
                    <div className="mh-now-grid">
                        {nowCards.map((card) => (
                            <article className="mh-now-card" key={card.title}>
                                <img src={card.image} alt={card.title}/>
                                <div className="mh-now-card__overlay">
                                    <h4>{card.title}</h4>
                                    <div className="mh-now-card__footer">
                                        <p>{card.text}</p>
                                        <Link to="/twentytwentysix/events" className="mh-inline-btn">
                                            Events →
                                        </Link>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                    <Link className="mh-link-row" to="/twentytwentysix/events">
                        All Events →
                    </Link>
                </div>
            </section>

            <section className="mh-programs section-charcoal">
                <div className="mh-container">
                    <h3 className="mh-section-title mh-section-title--center mh-section-title--light">
                        SIGNATURE MAMAHOOD PROGRAMS
                    </h3>

                    <div className="mh-program-list">
                        {programs.map((program) => (
                            <article
                                                                                                                                                                                    className={`mh-program-card ${program.theme}`}
                                key={program.title}
                                style={{
                                    "--program-image-position": program.imagePosition || "50% 40%",
                                    "--program-image-scale": program.imageScale || 1,
                                }}
                            >
                                <div className="mh-program-card__media">
                                    <img src={program.image} alt={program.title}/>
                                </div>

                                <div className="mh-program-card__overlay">
                                    <h4>{program.title}</h4>
                                    <Link to="/twentytwentysix/programs" className="mh-pill mh-pill--gold">
                                        More Info →
                                    </Link>
                                    <p>{program.subtitle}</p>
                                </div>
                            </article>
                        ))}
                    </div>


                    <Link className="mh-link-row mh-link-row--light" to="/twentytwentysix/programs">
                        All Programs →
                    </Link>
                </div>
            </section>

            <section className="mh-testimonials section-light">
                <div className="mh-container">
                    <h3 className="mh-section-title mh-section-title--center">
                        WHAT OTHER MAMAS ARE SAYING:
                    </h3>

                    <div className="mh-testimonial-list">
                        {testimonials.map((item, index) => (
                            <article
                                className={`mh-testimonial ${item.reverse ? "reverse" : ""}`}
                                key={item.quote + index}
                                style={{
                                    "--testimonial-image-position": item.imagePosition ?? "50% 40%",
                                    "--testimonial-image-scale": item.imageScale ?? 1,
                                }}
                            >
                                <div className="mh-testimonial__media">
                                    <img src={item.image} alt={item.author}/>
                                </div>
                                <div className={`mh-testimonial__content ${item.theme}`}>
                                    <h4>{item.quote}</h4>
                                    <p>{item.body}</p>
                                    <strong>{item.author}</strong>
                                    <span>{item.meta}</span>
                                </div>
                            </article>
                        ))}
                    </div>

                    <Link className="mh-link-row" to="/twentytwentysix/reviews">
                        More Reviews →
                    </Link>
                </div>
            </section>

            <section className="mh-mlist-hero">
                <img src="/static/img/m_list_banner_mobile.png" alt="M List resources banner"/>
                <div className="mh-mlist-hero__badge">M LIST</div>
            </section>

            <section className="mh-mlist section-cream">
                <div className="mh-container">
                    <h3 className="mh-section-title mh-section-title--center">THE M LIST</h3>
                    <p className="mh-copy mh-copy--center">
                        Browse through our list of local resources that have been vetted and
                        vouched for by The Mamahood, wearing the M List seal.
                    </p>
                    <div className="mh-center-actions">
                        <Link to="/twentytwentysix/mlist" className="mh-pill mh-pill--gold">
                            Browse the M List →
                        </Link>
                        <Link to="/twentytwentysix/mlist" className="mh-pill mh-pill--gold">
                            Join the M List →
                        </Link>
                    </div>

                    <h4 className="mh-section-title mh-section-title--center">CATEGORIES:</h4>

                    <div className="mh-category-grid">
                        {categories.map((category) => (
                            <article className="mh-category-card" key={category.title}>
                                <img src={category.image} alt={category.title}/>
                                <div className="mh-category-card__overlay">
                                    <h5>{category.title}</h5>
                                    <Link to="/twentytwentysix/mlist" className="mh-inline-btn">
                                        More Info →
                                    </Link>
                                </div>
                                <div className="mh-category-links">
                                    {category.ctas.map((cta) => (
                                        <Link to="/twentytwentysix/mlist" className="mh-category-link" key={cta}>
                                            {cta} →
                                        </Link>
                                    ))}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="mh-collective section-light" id="membership">
                <div className="mh-container">
                    <h3 className="mh-section-title mh-section-title--center">
                        THE MAMAHOOD COLLECTIVE
                    </h3>

                    <div className="mh-collective-grid">
                        <div className="mh-collective-info">
                            <h4>Join 800+ Women Entrepreneurs Building Sustainable Businesses</h4>
                            <div className="mh-round-logo mh-round-logo--xl">TMC</div>
                            <p>
                                For mom founders, entrepreneurs, creatives, and leaders, a
                                private collective for women+ founders, creatives, and service
                                providers in the Bay Area.
                            </p>
                            <Link to="/twentytwentysix/collective" className="mh-pill mh-pill--gold">
                                Find out more →
                            </Link>

                            <blockquote className="mh-quote-chip">
                                &quot;...a game changer...&quot;
                                <span>
                  Sarah Johnson, entrepreneur, founder of Cotton &amp; Lace
                </span>
                            </blockquote>
                        </div>

                        <div className="mh-founder-panel">
                            <h4 className="mh-section-title mh-section-title--center">
                                FEATURED FOUNDERS:
                            </h4>
                            <img src="/static/img/AdobeStock_179076750.jpeg" alt="Featured founder"/>
                            <div className="mh-founder-panel__body">
                                <div>
                                    <span className="mh-founder-brand">LOVELY</span>
                                </div>
                                <div>
                                    <h5>Abby Gale</h5>
                                    <p>
                                        Founder &amp; CEO of Lovely Clothing Co. Collective Member
                                        since 2014
                                    </p>
                                    <p>
                                        Read article featuring Abby in Fashion Mag Zine issue Sept
                                        2025
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Link className="mh-link-row" to="/twentytwentysix/join">
                        Become a Member →
                    </Link>
                </div>
            </section>

            <section className="mh-about section-charcoal">
                <div className="mh-container">
                    <div className="mh-about-grid">
                        <div className="mh-about-founder">
                            <img src="/static/img/AdobeStock_179076750.jpeg" alt="Heather Anderson"/>
                            <div className="mh-about-founder__caption">
                                <h4>Heather Anderson</h4>
                                <p>Founder, The Mamahood</p>
                            </div>

                            <div className="mh-region-row mh-region-row--compact">
                                <button type="button" className="mh-pill mh-pill--region teal">
                                    San Francisco Bay Area →
                                </button>
                                <button type="button" className="mh-pill mh-pill--region teal">
                                    Sacramento Valley →
                                </button>
                                <button type="button" className="mh-pill mh-pill--region teal">
                                    LA County →
                                </button>
                            </div>
                        </div>

                        <div className="mh-about-copy">
                            <h3 className="mh-section-title mh-section-title--light">
                                ABOUT THE MAMAHOOD
                            </h3>
                            <p>
                                The Mamahood is the largest, most diverse, support community for
                                over 100,000 mothers in CA, with chapters in the Bay Area,
                                Sacramento Valley, and LA County.
                            </p>
                            <p>
                                We are an inclusive, social justice focused community, providing
                                empathy, resources, and inspiration to mothers and non-binary
                                parents of all ages and stages of life.
                            </p>
                            <p>
                                Heather Anderson, Marketing and Brand Strategist, Founder of The
                                Mamahood and The Mamahood Collective, lives for business
                                launches, startups and phrases like &quot;user acquisition,&quot;
                                &quot;strategic partnership&quot; and &quot;engagement.&quot;
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="mh-footer">
                <div className="mh-container mh-footer__grid">
                    <div className="mh-footer__links">
                        <Link to="/twentytwentysix/contact">Contact</Link>
                        <Link to="/twentytwentysix/resources">Resources</Link>
                        <Link to="/twentytwentysix/podcasts">Podcasts</Link>
                        <Link to="/twentytwentysix/events">Events</Link>
                        <Link to="/twentytwentysix/membership">Membership</Link>
                        <Link to="/twentytwentysix/login">Member Sign-In</Link>
                    </div>

                    <div className="mh-footer__brand">
                        <div className="mh-round-logo">M</div>
                        <div className="mh-socials">
                            <span>f</span>
                            <span>ig</span>
                            <span>in</span>
                        </div>
                    </div>

                    <form className="mh-newsletter" onSubmit={(e) => e.preventDefault()}>
                        <h4>NEWSLETTER SIGN-UP!</h4>
                        <div className="mh-newsletter__row">
                            <input type="text" placeholder="First Name" aria-label="First Name"/>
                            <input type="text" placeholder="Last Name" aria-label="Last Name"/>
                        </div>
                        <input type="email" placeholder="Email Address" aria-label="Email Address"/>
                        <button type="submit" className="mh-pill mh-pill--gold">
                            Submit →
                        </button>
                    </form>
                </div>
            </footer>
        </div>
    )

}
